import React from "react";
import { Droppable, Draggable } from "@hello-pangea/dnd";
import "./Snippets.css";

const dragIcon = (
  <i
    className={"bi bi-arrows-move me-3"}
    style={{ fontSize: "14px", color: "grey" }}
  />
);

export default function SnippetSelection({
  providedSnippets,
}: {
  providedSnippets: string[];
}) {
  return (
    <>
      <Droppable
        droppableId="snippetSelection"
        direction="horizontal"
        isDropDisabled
      >
        {(droppableProvided) => (
          <div
            className="snippetsstyle"
            {...droppableProvided.droppableProps}
            ref={droppableProvided.innerRef}
          >
            {providedSnippets.map((name, index) => {
              return (
                <Draggable
                  key={index.toString()}
                  draggableId={index.toString()}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <>
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                          ...provided.draggableProps.style,
                          transform: snapshot.isDragging
                            ? provided.draggableProps.style?.transform
                            : "translate(0px, 0px)",
                        }}
                      >
                        {dragIcon}
                        <code className="inline">{name}</code>
                      </div>

                      {snapshot.isDragging && (
                        <div style={{ transform: "none !important" }}>
                          {dragIcon}
                          <code className="inline">{name}</code>
                        </div>
                      )}
                    </>
                  )}
                </Draggable>
              );
            })}

            <span style={{ display: "none" }}>
              {droppableProvided.placeholder}
            </span>
          </div>
        )}
      </Droppable>
    </>
  );
}
